module.exports = __webpack_public_path__ + "img/JKlogo.a4df1f2f.png";